import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../store/store";
import { deleteQuestion, updateQuestion } from "../store/features/CreateSurveySlice";
import { deleteSurveyQuestion, updateSurveyQuestion } from "../Firebase/utils";
import { TbArrowBadgeRightFilled } from "react-icons/tb";
import CustomDropdown from "./CustomDropdown";
import { Question } from "../types";
import DropDownSelectionForm from "./DropDownSelectionForm";
import QuestionPreviewContainer from "./QuestionPreviewContainer";
import useDeleteSurveyQuestion from "../CustomHooks/useDeleteSureveyQuestion";

interface DropdownSelectionOptionsPreviewDisplayProps {
    question: Question,
    questionText: string;
    options: string[];
    value?: string;
    setValue?: (value: string) => void;
}

export default (props: DropdownSelectionOptionsPreviewDisplayProps) => {

    const { question, questionText, options } = props;
    const pathName = useLocation().pathname.split('/')[1];
    const dispatch = useAppDispatch();
    const user = useAppSelector(state => state.user.user);
    const survey = useAppSelector(state => state.survey.survey);
    const [ modalOpen, setModalOpen ] = useState<boolean>(false);
    
    const { deleteQuestion, loading, error } = useDeleteSurveyQuestion(survey, question);

    const handleEditQuestion = () => {
        setModalOpen(true);
        // try{
        //     updateSurveyQuestion(user, survey, question);
        //     dispatch(updateQuestion(question));
        // }catch(err){
        //     console.error(err);
        // }        
    }

    return (
        <QuestionPreviewContainer question={question} handleDeleteQuestion={() => deleteQuestion()} handleEditQuestion={handleEditQuestion}>
            <div className="flex flex-col gap-4">
                <CustomDropdown label="Select One" options={options} selectedOption={options[0]} setSelectedOption={(option: string) => {}}/>
                {/* <ul className="flex flex-col gap-5">
                    {options.map((option: string) => {
                        return (
                                <li key={option} className="flex items-center gap-2 text-xl"><TbArrowBadgeRightFilled className="text-[#3da8e2] text-3xl"/>{option}</li>
                        );
                    })}
                </ul> */}
            </div>
            <DropDownSelectionForm openState={modalOpen} onClose={setModalOpen} question={question}/>
        </QuestionPreviewContainer>
    )
}